<div class="blogs-container">
    <div class="blog-container">
        <div class="thumb-img">
            <img [src]="blog.thumbnailUrl" />
        </div>
        <div class="innerhtml" [innerHTML]="blog.innerHtml"></div>
    </div>
</div>